/**
 * Cleans a phone number by removing all non-numeric characters
 * @param {string} phoneNumber - The phone number to clean
 * @returns {string} - The cleaned phone number (digits only)
 */
export const cleanPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';
  return phoneNumber.replace(/\D/g, '');
};

/**
 * Validates a phone number format
 * @param {string} phoneNumber - The phone number to validate
 * @param {boolean} allowEmpty - Whether to allow empty phone numbers (defaults to true)
 * @returns {boolean} - True if phone number format is valid or (empty and allowEmpty=true), false otherwise
 */
export const validatePhoneNumber = (phoneNumber, allowEmpty = true) => {
  if (!phoneNumber) {
    return allowEmpty;
  }

  const cleaned = cleanPhoneNumber(phoneNumber);
  
  // Valid if exactly 10 digits
  if (cleaned.length === 10) {
    return true;
  }
  
  // Valid if 11 digits starting with 1
  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    return true;
  }

  return false;
};

/**
 * Formats a phone number to a standardized 10-digit format
 * @param {string} phoneNumber - The phone number to format
 * @returns {string} - The formatted 10-digit phone number or empty string if invalid
 */
export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';
  
  const cleaned = cleanPhoneNumber(phoneNumber);
  
  if (cleaned.length === 10) {
    return cleaned;
  }
  
  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    return cleaned.substring(1);
  }
  
  return '';
};
